import { render, staticRenderFns } from "./taskCreate.vue?vue&type=template&id=76b72efd&scoped=true"
import script from "./taskCreate.vue?vue&type=script&lang=js"
export * from "./taskCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76b72efd",
  null
  
)

export default component.exports